import { render, staticRenderFns } from "./cms-block-faq-list.vue?vue&type=template&id=0618698c&scoped=true"
import script from "./cms-block-faq-list.vue?vue&type=script&lang=js"
export * from "./cms-block-faq-list.vue?vue&type=script&lang=js"
import style0 from "./cms-block-faq-list.vue?vue&type=style&index=0&id=0618698c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0618698c",
  null
  
)

export default component.exports